import axios from 'axios';
import { UserProfile, UserProgressItem } from '../types/user';

export const USER_ID_KEY = 'judoUserId';

function authHeaders() {
  const token = btoa(`${process.env.REACT_APP_API_USERNAME}:${process.env.REACT_APP_API_PASSWORD}`);
  return { Authorization: `Basic ${token}` };
}

const base = () => process.env.REACT_APP_API_URL;

export const userService = {
  async getUser(id: string): Promise<UserProfile> {
    const res = await axios.get<UserProfile>(`${base()}/User/${id}`, {
      headers: authHeaders(),
    });
    return res.data;
  },

  async createUser(username: string, pin: string): Promise<UserProfile> {
    const res = await axios.post<UserProfile>(
      `${base()}/User`,
      { username, pin },
      { headers: authHeaders() }
    );
    return res.data;
  },

  async recordTraining(id: string, xpEarned: number): Promise<UserProfile> {
    const res = await axios.put<UserProfile>(
      `${base()}/User/${id}/training`,
      { xpEarned },
      { headers: authHeaders() }
    );
    return res.data;
  },

  async getProgress(userId: string): Promise<UserProgressItem[]> {
    const res = await axios.get<UserProgressItem[]>(`${base()}/User/${userId}/Progress`, {
      headers: authHeaders(),
    });
    return res.data;
  },

  async upsertProgress(
    userId: string,
    curriculumId: string,
    masteryLevel: number
  ): Promise<UserProgressItem> {
    const res = await axios.post<UserProgressItem>(
      `${base()}/User/${userId}/Progress`,
      { curriculumId, masteryLevel },
      { headers: authHeaders() }
    );
    return res.data;
  },
};
